export default __webpack_public_path__ + "static/media/Chestguard of Heroic Soul.d55b472a.jpg";